import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';
import { PageHeader } from '@/components/layout/page-header';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useBusiness } from '@/features/auth/auth.store';
import { DeliveriesSearch } from './deliveries-search';
import { DeliveriesSorting } from './deliveries-sorting';

/**
 * Third-party deliveries for the selected store.
 *
 * The route is only mounted for a client that has the feature, and only for
 * the roles allowed in; what is left to check here is the store. As in the
 * original, a store without delivery switched on — or no store at all — is
 * sent home rather than shown an empty page.
 */
export function DeliveriesPage() {
  const { t } = useTranslation();
  const business = useBusiness();

  if (!business?.allowDelivery) return <Navigate to="/" replace />;

  return (
    <div className="space-y-6">
      <PageHeader
        title={t('deliveries.title')}
        description={business.name}
      />

      {/* Keyed on the store, so switching store starts both tabs afresh
          instead of carrying one store's provider and zone into the next. */}
      <Tabs key={business.id} defaultValue="search">
        <TabsList className="sm:w-auto">
          <TabsTrigger value="search">{t('deliveries.searchTab')}</TabsTrigger>
          <TabsTrigger value="sorting">
            {t('deliveries.sortingTab')}
          </TabsTrigger>
        </TabsList>
        <TabsContent value="search">
          <DeliveriesSearch business={business} />
        </TabsContent>
        <TabsContent value="sorting">
          <DeliveriesSorting business={business} />
        </TabsContent>
      </Tabs>
    </div>
  );
}
